
<app-frms-messagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>
<div class="thumbgallery-container">
  <div class="thumbgallery-toolbar d-flex">
    <div class="header"> <span class="header-content"> <i class="far fa-images mr-1"></i> <b>Flight Image gallery</b> <small class="ml-2">{{imagesCountDesc}}</small>  </span>  </div>
    <div class="ml-auto thumbgallery-toolbar-buttons">
        <frms-searchbox [tooltip]="'Enter image name'" [placeholder]="'Find image by name'" (find_event)="findimage_click_handler($event)"></frms-searchbox>
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="gallery_addissue_fromselected()"  matTooltip="Add issue from selected image"><i class="far fa-window-close"></i></button>
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="gallery_expandSelectedImage()"  matTooltip="Show selected image in high resolution"><i class="fas fa-expand-alt"></i></button>
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="gallery_playflight()"  matTooltip="Play/Stop animation of images taken" ><i class="{{playGallery_class}}"></i></button>
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="close()"><i class="fas fa-times"></i></button>
    </div>
  </div>
  <div class="progress-bar">
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
  </div>
  
  <div class="thumbgallery-gallery-container">
    <cdk-virtual-scroll-viewport #gallery orientation="horizontal" itemSize="128" class="thumbgallery-viewport">
      <!-- (contextmenu)="thumbOnRightClick($event,item,idx)" -->
      <div *cdkVirtualFor="let item of galleryImagesStore; let idx = index;" class="thumbgallery-item" 
      (click)="thumbclick($event,item,idx)"        
        >
          <app-img-thumb [item]="item" 
          [selectedIndex]="selectedIndex" 
          [idx]="idx"  
          [options]="{showLabels:true,clickable:true}"
          (addissue_event)="gallery_addissuefromimageitem($event)"
          (expandImage_event)="gallery_expandSelectedImageByImageItem($event)"
          (show_event)="gallery_showImageOnMap($event,idx)"
          ></app-img-thumb>
        

      </div>
    </cdk-virtual-scroll-viewport>
  </div>
</div>

<ng-template #ctxMenu let-item>
  <section class="ctx-menu">
    <div *ngFor="let action of item.actions" (click)="action.action($event, item)">{{action.description}}</div>
  </section>
</ng-template>

<!--  -->